import React from 'react'

export default class MessageTray extends React.Component {
	constructor(props) {
		super(props);
		notifications.flush();
		this.handlerChange = notifications.addHandler(this.onChangeMessages.bind(this));
	}

	onChangeMessages(msgs) {
		this.forceUpdate();
	}

	componentWillUnmount() {
		notifications.removeHandler(this.handlerChange);
	}

	onClose() {
		notifications.clear();
	}

	render() {
		if (notifications.msgs.length == 0) {
			return null;
		}
		const msgs = notifications.msgs.map( ( msg, i ) =>
			<span key={i} dangerouslySetInnerHTML={ (() => { return {__html: msg.msg} })() } title={msg.title || null} />
		);

		return (
			<div className='msg-tray'>
				<div className='inner'>
					<em className='la la-check' />
					<span className='content'>{msgs}</span>
					<a className="close" title={trans.get('attrs_close')} onClick={this.onClose.bind(this)}>
						<span className="la la-close"/>
					</a>
				</div>
			</div>
		);
	}
}
